'use strict';

wbApp.factory('courseRegistrationCommonSvc', [
    '$http', '$q', 'notificationSvc', '$translate',
    'promotionSvc', 'securitySvc', 'coursePriceSvc',
    function ($http, $q, notificationSvc, $translate, promotionSvc, securitySvc, coursePriceSvc) {

        function prepareModelAsync(c, isAction) {
            var deferred = $q.defer();

            var m = { students: c.students };
            delete c.students;

            if (isAction) {
                m.action = c;
            } else {
                m.course = c;
            }

            c.courseFullName = !!c.courseAbbreviation
                ? c.courseName + '(' + c.courseAbbreviation + ')'
                : c.courseName;

            var promotionNow = c.nearestLesson === "0001-01-01T00:00:00"
                ? new Date()
                : c.nearestLesson;

            if (securitySvc.loggedInUser().isAuthenticated) {
                promotionSvc.getPromotionsByStudentsAsync(
                    securitySvc.loggedInUser().userID,
                    m.students,
                    isAction ? 'action' : 'course',
                    promotionNow,
                    false /* isAdmin */)
                .$promise.then(function (promoByStudent) {
                    for (var s = 0; s < m.students.length; s++) {
                        var student = m.students[s];
                        student.promotions = promoByStudent[student.studentID];
                    }

                    deferred.resolve(m);
                });
            } else {
                deferred.resolve(m);
            }

            m.$promise = deferred.promise;
            return m;
        }


        function setUpCoursePrices(course, students) {
            for (var s = 0; s < students.length; s++) {
                var student = students[s];

                if (student.isEditable) {
                    var priceDetails = coursePriceSvc.getPriceDetails(course, student);
                    student.priceDetails = priceDetails;
                } else {
                    student.priceDetails = {};
                }
            }
        }

        function getConfirmRegistrationDescription(students, origStudents, course, isAction) {

            var regResult = '';
            var unRegResult = '';

            var regPlular = false;
            var regStudents = '';

            var unRegPlular = false;
            var unRegStudents = '';

            for (var idx = 0; idx < students.length; idx++) {
                var student = students[idx];
                var origStudent = getOrigStudent(student.studentID, origStudents);

                if (student.attend &&
                    student.attend !== origStudent.attend) {
                    if (regStudents) {
                        regStudents = regStudents + ', ' + student.studentFullName;
                        regPlular = true;
                    } else {
                        regStudents = student.studentFullName;
                    }
                } else {
                    if (!student.attend &&
                        student.attend !== origStudent.attend) {
                        if (unRegStudents) {
                            unRegStudents = unRegStudents + ', ' + student.studentFullName;
                            unRegPlular = true;
                        } else {
                            unRegStudents = student.studentFullName;
                        }
                    }
                }
            }

            if (regStudents) {
                if (regPlular) {
                    regResult = $translate.instant('TXT_STUDENT_PLULAR') + ' ' + regStudents;
                } else {
                    regResult = $translate.instant('TXT_STUDENT_SINGULAR') + ' ' + regStudents;
                }
            }

            if (unRegStudents) {
                if (unRegPlular) {
                    unRegResult = $translate.instant('TXT_STUDENT_PLULAR') + ' ' + unRegStudents;
                } else {
                    unRegResult = $translate.instant('TXT_STUDENT_SINGULAR') + ' ' + unRegStudents;
                }
            }

            if (isAction) {
                if (regResult) {
                    regResult = $translate.instant('TXT_REGISTER_TO_ACTION_DESC').f(
                        regResult,
                        course.subjectName + ' ' + course.name);
                }
                if (unRegResult) {
                    unRegResult = $translate.instant('TXT_UNREGISTER_FROM_ACTION_DESC').f(
                        unRegResult,
                        course.subjectName + ' ' + course.name);
                }
            } else {
                if (regResult) {
                    regResult = $translate.instant('TXT_REGISTER_TO_COURSE_DESC').f(
                        regResult,
                        course.subjectName + ' ' + course.name);
                }
                if (unRegResult) {
                    unRegResult = $translate.instant('TXT_UNREGISTER_FROM_COURSE_DESC').f(
                        unRegResult,
                        course.subjectName + ' ' + course.name);
                }
            }

            return { regDescription: regResult, unRegDescription: unRegResult };
        }

        function getOrigStudent(studentID, origStudents) {

            if (!origStudents) {
                return { attend: false };
            }

            for (var idx = 0; idx < origStudents.length; idx++) {
                var os = origStudents[idx];
                if (os.studentID === studentID) {
                    return os;
                }
            }

            return { attend: false };
        }

        function getConfirmRegistrationStudents(students, origStudents, includeAll) {
            var result = [];
            for (var idx = 0; idx < students.length; idx++) {
                var student = students[idx];
                if (student.attend &&
                    student.isEditable &&
                    student.attend !== getOrigStudent(student.studentID, origStudents).attend) {
                    var newCopy = angular.copy(student);
                    newCopy.newRegistration = true;
                    result.push(newCopy);
                } else {
                    if (includeAll) {
                        var existingCopy = angular.copy(student);
                        existingCopy.newRegistration = false;
                        result.push(existingCopy);
                    }
                }
            }

            return result;
        }

        function updatePriceDetails(course, student) {
            var priceDetails = coursePriceSvc.getPriceDetails(course, student);
            student.priceDetails = priceDetails;
        }

        return {
            prepareModelAsync: prepareModelAsync,
            setUpCoursePrices: setUpCoursePrices,
            getConfirmRegistrationDescription: getConfirmRegistrationDescription,
            getConfirmRegistrationStudents: getConfirmRegistrationStudents,
            updatePriceDetails: updatePriceDetails
        }
    }]);